import React from "react";
import { Routes, Route } from "react-router-dom";

// =====================================================
// PUBLIC PAGES
// =====================================================

import LoginPage from "../pages/LoginPage";

// =====================================================
// ADMIN PAGES
// =====================================================

import DashboardPage from "../pages/admin/DashboardPage";
import AddEmployeePage from "../pages/admin/AddEmployeePage";
import EmployeeGridPage from "../pages/admin/EmployeeGridPage";
import EditEmployeePage from "../pages/admin/EditEmployeePage";

import SettingsPage from "../pages/admin/SettingsPage";

import LoginFilesPage from "../pages/admin/LoginFilesPage";
import AssignedFilesPage from "../pages/admin/AssignedFilesPage";
import CompletedFilesPage from "../pages/admin/CompletedFilesPage";

import CreateFilePage from "../pages/admin/CreateFilePage";
import EditCreateFilePage from "../pages/admin/EditCreateFilePage";

import QueryRaisedFilesPage from "../pages/admin/QueryRaisedFilesPage.jsx";
import QueryRaisedToBankFilesPage from "../pages/admin/QueryRaisedToBankFilesPage.jsx";

import ManageFiles from "../pages/admin/ManageFiles.jsx";
import AdminFileView from "../pages/admin/AdminFileView.jsx";

// =====================================================
// ADMIN SETTINGS
// =====================================================

import ProfileSetupPage from "../pages/admin/settings/ProfileSetupPage";
import BankBranchesPage from "../pages/admin/settings/BankBranchesPage";
import BankProductsPage from "../pages/admin/settings/BankProductsPage";
import YaazhBranchesPage from "../pages/admin/settings/YaazhBranchesPage";

import FileFormatMasterGridsPage from "../pages/admin/settings/FileFormatMasterGridsPage.jsx";
import FileFormatMasterPage from "../pages/admin/settings/FIleFormatMasterPage.jsx";
import FileFormatAddEditPage from "../pages/admin/settings/FileFormatAddEditPage.jsx";

// =====================================================
// PROCESSOR PAGES
// =====================================================

import ProcessorDashboardPage from "../pages/processor/ProcessorDashboardPage";
import ProcessorAssignedFilesPage from "../pages/processor/ProcessorAssignedFilesPage";
import ProcessorFileView from "../pages/processor/ProcessorFileView";
import ProcessorSettingsPage from "../pages/processor/ProcessorSettingsPage.jsx";
import ProcessorCompletedFilesPage from "../pages/processor/ProcessorCompletedFilesPage.jsx";
import ProcessorQueryUploadedFilesPage from "../pages/processor/QueryUploadedFilesPage.jsx";

// =====================================================
// EXPENSE PAGES
// =====================================================

import ExpenseGridPage from "../pages/expenses/ExpenseListPage.jsx";
import ExpenseCreatePage from "../pages/expenses/ExpenseCreatePage.jsx";
import ExpenseDynamicPage from "../pages/expenses/ExpenseDynamicPage.jsx";
import ExpenseApprovalPage from "../pages/expenses/ExpenseApprovalPage.jsx";

// =====================================================
// LAYOUT / AUTH
// =====================================================

import MainLayout from "../layouts/MainLayout";
import PrivateRoute from "./PrivateRoute";

// =====================================================
// NOTIFICATION
// =====================================================

import { NotificationProvider } from "../context/NotificationContext";


// =====================================================
// APP ROUTES
// =====================================================

export default function AppRoutes() {
  return (
    <NotificationProvider>
      <Routes>

        {/* =================================================
            PUBLIC ROUTES
        ================================================= */}

        <Route
          path="/"
          element={<LoginPage />}
        />

        <Route
          path="/login"
          element={<LoginPage />}
        />


        {/* =================================================
            DASHBOARD
        ================================================= */}

        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            EMPLOYEE
        ================================================= */}

        <Route
          path="/employee/register"
          element={
            <PrivateRoute>
              <MainLayout>
                <AddEmployeePage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/employee/edit/:id"
          element={
            <PrivateRoute>
              <MainLayout>
                <EditEmployeePage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/employees"
          element={
            <PrivateRoute>
              <MainLayout>
                <EmployeeGridPage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            SETTINGS
        ================================================= */}

        <Route
          path="/settings/profile"
          element={
            <PrivateRoute>
              <MainLayout>
                <ProfileSetupPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/bank-branches"
          element={
            <PrivateRoute>
              <MainLayout>
                <BankBranchesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/bank-products"
          element={
            <PrivateRoute>
              <MainLayout>
                <BankProductsPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/yaazh-branches"
          element={
            <PrivateRoute>
              <MainLayout>
                <YaazhBranchesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            FILE FORMAT SETTINGS
        ================================================= */}

        <Route
          path="/settings/file-format-setup"
          element={
            <PrivateRoute>
              <MainLayout>
                <FileFormatMasterGridsPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/file-format-master"
          element={
            <PrivateRoute>
              <MainLayout>
                <FileFormatMasterPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/file-format-add"
          element={
            <PrivateRoute>
              <MainLayout>
                <FileFormatAddEditPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/settings/file-format-edit/:id"
          element={
            <PrivateRoute>
              <MainLayout>
                <FileFormatAddEditPage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            ADMIN FILES
        ================================================= */}

        <Route
          path="/login-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <LoginFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/assigned-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <AssignedFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/query-raised-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <QueryRaisedFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/query-raised-to-bank-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <QueryRaisedToBankFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/completed-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <CompletedFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            PROCESSOR
        ================================================= */}

        <Route
          path="/processor-dashboard"
          element={
            <PrivateRoute>
              <MainLayout>
                <ProcessorDashboardPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/processor-assigned-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <ProcessorAssignedFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/processor-query-uploaded-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <ProcessorQueryUploadedFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/processor-completed-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <ProcessorCompletedFilesPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/processor-settings"
          element={
            <PrivateRoute>
              <MainLayout>
                <ProcessorSettingsPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/processor-file-view/:id"
          element={
            <PrivateRoute>
              <MainLayout minimalLayout={true}>
                <ProcessorFileView />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            CREATE / EDIT FILE
        ================================================= */}

        <Route
          path="/create-file"
          element={
            <PrivateRoute>
              <MainLayout>
                <CreateFilePage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/edit-file/:id"
          element={
            <PrivateRoute>
              <MainLayout>
                <EditCreateFilePage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            EXPENSES
        ================================================= */}

        <Route
          path="/expenses"
          element={
            <PrivateRoute>
              <MainLayout>
                <ExpenseGridPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/expenses/view/:id"
          element={
            <PrivateRoute>
              <MainLayout>
                <ExpenseDynamicPage />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/expenses/ExpenseDynamicPage"
          element={
            <PrivateRoute>
              <MainLayout>
                <ExpenseDynamicPage />
              </MainLayout>
            </PrivateRoute>
          }
        />


        {/* =================================================
            MANAGE FILES
        ================================================= */}

        <Route
          path="/manage-files"
          element={
            <PrivateRoute>
              <MainLayout>
                <ManageFiles />
              </MainLayout>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin-file-view/:id"
          element={
            <PrivateRoute>
              <MainLayout>
                <AdminFileView />
              </MainLayout>
            </PrivateRoute>
          }
        />

      </Routes>
    </NotificationProvider>
  );
}